import { render, staticRenderFns } from "./zhuanti-guojijingji.vue?vue&type=template&id=dfff0916&"
import script from "./zhuanti-guojijingji.vue?vue&type=script&lang=js&"
export * from "./zhuanti-guojijingji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports